module.exports = __webpack_public_path__ + "favicon-32x32.620e1109.png";